import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function HowItWorks(props) {
  return <div>how it works</div>;
}

export default HowItWorks;
